module.exports = __webpack_public_path__ + "static/OR1-0f3042d048b69145f388b704a9b260f0.jpg";